/* RESPONSIBLE TEAM: team-inbox */
const AVAILABLE_EMOJI = [
  '🚀',
  '🌟',
  '🎉',
  '🍻',
  '🎯',
  '🏆',
  '🎲',
  '💎',
  '🏭',
  '💡',
  '💰',
  '📈',
  '👾',
  '📢',
  '⚡',
  '🔮',
  '⏳',
  '✨',
  '🔥',
  '⭐',
  '✅',
  '🚨',
  '💈',
  '📡',
];
const DEFAULT_EMOJI = AVAILABLE_EMOJI[0];

export function randomEmoji() {
  return AVAILABLE_EMOJI[Math.floor(Math.random() * AVAILABLE_EMOJI.length)];
}

export { DEFAULT_EMOJI, AVAILABLE_EMOJI };
